import { createSlice } from "@reduxjs/toolkit";

export const allMaterialCategorySlice=createSlice({
    name:'allMaterialCategorySlice',
    initialState:{
        value:undefined
    },
    reducers:{
        update_material_category_list:(state,action)=>{
            state.value=action.payload.materialCategory
        }
    }
})

export const {update_material_category_list}=allMaterialCategorySlice.actions
export default allMaterialCategorySlice.reducer